import gql from 'graphql-tag';

export const MODIFY_STOCKTAKE_ITEM = gql`
	mutation modifyStocktakeMutation ($input: ModifyStocktakeItemInput!) {
		modifyStocktakeItem (input: $input) {
			stocktakeitem {
				id
				countedExpiryBatches
				# Item edits recalculate the parent stocktake's stats server-side; selecting
				# them here lets Apollo patch the cached stocktake so detail headers refresh
				# without refetching the whole item list.
				stocktake {
					id
					status
					percentageDifference
					valueOfDifference
					valueNotAccurate
				}
				warehouseProduct {
					id
					pickOrder
					quantity
					expiryBatchPreview
					expiryBatchSummary
					expiryBatches {
						id
						quantityOnHand
						expiryDate
						bestBeforeDate
						supplierBatchCode
						status
						receivedAt
						expiryDateSource
					}
					product {
						id
						name
						cost
						imageUrl
						destroyed
						measurementUnit
						shipperSize
						palletSize
						barcodes
					}
				}
				preStocktakeQuantity
				quantity
			}
		}
	}
`;
